import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import moment from 'moment';
import Stripe from 'stripe';
import { ModalService } from '../../../core/services/modal.service';
import { SubscriptionsAPIResponse } from '../../../types/responses';
import { StripeService } from '../../../core/services/stripe.service';

@Component({
	selector: 'app-stripe-stored-cards',
	templateUrl: './stripe-stored-cards.component.html',
	styleUrls: ['./stripe-stored-cards.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class StripeStoredCardsComponent implements OnInit {
	@Input() paymentMethods;

	@Input() primaryPaymentMethod;

	@Input() user;

	@Input() customer: Stripe.Customer;

	@Input() hideNewCardOption = false;

	@Output() selectedCard = new EventEmitter();

	@Output() useNewCard = new EventEmitter();

	@Output() cardHint = new EventEmitter();

	public selected;

	public displayMoreCards = false;

	public currentSubscription;

	constructor(
		private modalService: ModalService,
		private stripeService: StripeService,
	) { }

	ngOnInit(): void {
		if (this.primaryPaymentMethod) {
			this.selected = this.primaryPaymentMethod;
			this.setSelectedCard(this.primaryPaymentMethod);
			if (this.primaryPaymentMethod?.card?.last4) {
				this.cardHint.emit(this.primaryPaymentMethod.card.last4);
			}
		}
	}

	getExpirationDate(card) {
		const date = moment();
		date.set('year', card.exp_year);
		date.set('month', card.exp_month);

		return `Expiry ${date.format('MM/YYYY')}`;
	}

	setSelectedCard(paymentMethod) {
		this.selected = paymentMethod;
		this.selectedCard.emit(paymentMethod.id);
	}

	openCardsModal() {
		this.modalService.open('list-cards');
	}

	getSubscriptions() {
		this.stripeService.getSubscriptions(this.user._id).subscribe((result: SubscriptionsAPIResponse) => {
			if (result.success) {
				// Get current subscription if any
				const lastSubscriptions = result.subscriptions.filter((subscription) => subscription.isLastSubscription);
				this.currentSubscription = lastSubscriptions.length > 0 ? lastSubscriptions[0] : false;
				// Flag for active subscription
			}
		});
	}
}
